import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import ExitScreenComponent from '../components/exitScreen/ExitScreen';

const getExitScreen = state => state.scene.exitScreen;

const exitScreenItems = createSelector(getExitScreen, exitItems =>
  exitItems.filter((item, idx) => idx < 4),
);
const mapStateToProps = state => ({
  exitScreen: exitScreenItems(state),
});

const mapDispatchToProps = () => ({
  exitClick: link => {
    analytics.event({
      category: 'Navigation',
      action: 'ExitLink',
    });
    window.open(link, 'new');
  },
});

const ExitScreen = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExitScreenComponent);

export default ExitScreen;
